import axios from 'axios';
import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import Spinner from '../../components/Spinner/Spinner';
import BPOLogo from '../../images/bpoLogo.jpg';
import '../AuthPage/authpage.scss';
import { URL } from '../../constants';
import { toast } from 'react-toastify';
import { Button as MUIButton } from '@mui/material';

function ResetPassword() {
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (id && token) {
      resetPasswordConfirm();
    } else {
      getEmailToReset();
    }
  };

  const { id, token } = useParams();

  const [isLoadingLocal, setIsLoadingLocal] = useState(false);

  const [emailToReset, setEmailToReset] = useState('');
  const getEmailToReset = () => {
    setIsLoadingLocal(true);
    axios
      .post(URL + 'core/reset-password/', {
        email: emailToReset,
        url: window.location.origin,
      })
      .then(() => {
        toast.success('Email sent successfully.Please check your email');
        setTimeout(() => {
          navigate('/');
        }, 1000);
      })
      .catch((err) => {
        toast.error('Could not send email');
      })
      .finally(() => {
        setIsLoadingLocal(false);
      });
  };

  const [new_password, setNew_password] = useState('');
  const resetPasswordConfirm = () => {
    setIsLoadingLocal(true);
    axios
      .post(URL + 'auth/users/reset_password_confirm/', {
        uid: id,
        new_password,
        token,
      })
      .then(() => {
        toast.success('Password reset successfully.Please login with new password');
        navigate('/');
      })
      .catch((err) => {
        if ('new_password' in err.response?.data || 'uid' in err.response?.data) {
          err.response?.data['uid']?.forEach((item) => {
            toast.error(item);
            return;
          });
          err.response?.data['new_password']?.forEach((item) => {
            toast.error(item);
          });
        } else {
          toast.error('Something went wrong');
          navigate('/');
        }
      })
      .finally(() => {
        setIsLoadingLocal(false);
      });
  };

  return (
    <>
      {isLoadingLocal && <Spinner />}
      <div className="authpage">
        <img src={BPOLogo} alt="BPO Logo" className="bpologo" />
        <div className="authpage__card">
          <h1>Reset Password</h1>
          <form onSubmit={handleSubmit}>
            {token && id ? (
              <Input
                placeholder="Enter new password"
                label="New Password"
                required
                minLength="8"
                type="password"
                value={new_password}
                onChange={(e) => setNew_password(e.target.value)}
              />
            ) : (
              <Input
                placeholder="Enter email"
                label="Email"
                required
                type="email"
                value={emailToReset}
                onChange={(e) => setEmailToReset(e.target.value)}
              />
            )}
            <Button
              style={{
                marginTop: '20px',
                fontSize: '16px',
                padding: '10px',
                color: 'white',
                backgroundColor: 'var(--primary-color)',
                marginLeft: 'auto',
              }}
              type="submit"
              text="Reset Password"
            />
          </form>
          <MUIButton
            variant="text"
            color="primary"
            href="/"
            sx={{
              display: 'block',
              width: 'fit-content',
              margin: 'auto',
              marginBottom: '1rem',
              textTransform: 'capitalize',
            }}>
            Go to login
          </MUIButton>
        </div>
      </div>
    </>
  );
}

export default ResetPassword;
